import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { supabase } from '../lib/supabase';
import { COLORS } from '../lib/constants';

export default function ResetPasswordPage({ onDone }) {
  const { i18n } = useTranslation();
  const isRtl = i18n.language === 'ar';
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleReset = async () => {
    if (password.length < 6) { setError(isRtl ? 'كلمة المرور 6 أحرف على الأقل' : 'Password must be 6+ chars'); return; }
    if (password !== confirm) { setError(isRtl ? 'كلمتا المرور غير متطابقتين' : 'Passwords do not match'); return; }
    setLoading(true); setError('');
    const { error } = await supabase.auth.updateUser({ password });
    setLoading(false);
    if (error) { setError(isRtl ? 'تعذر تحديث كلمة المرور، حاول مرة أخرى' : 'Could not update password, please try again'); return; }
    setSuccess(true);
    setTimeout(() => onDone(), 2000);
  };

  return (
    <div style={{ minHeight: '100vh', background: `linear-gradient(135deg, ${COLORS.primary} 0%, ${COLORS.primaryDark} 100%)`, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16, fontFamily: 'Cairo, sans-serif' }}>
      <div style={{ background: '#fff', borderRadius: 24, padding: 32, width: '100%', maxWidth: 420, boxShadow: '0 25px 60px rgba(0,0,0,0.2)', direction: isRtl ? 'rtl' : 'ltr' }}>
        <div style={{ fontSize: 20, fontWeight: 800, color: COLORS.text, marginBottom: 6, textAlign: 'center' }}>{isRtl ? 'تعيين كلمة مرور جديدة' : 'Set a New Password'}</div>
        <div style={{ fontSize: 13, color: COLORS.textMuted, marginBottom: 20, textAlign: 'center' }}>{isRtl ? 'أدخل كلمة المرور الجديدة لحسابك' : 'Enter a new password for your account'}</div>

        {error && <div style={{ background: '#FEF2F2', border: '1px solid #FECACA', borderRadius: 10, padding: '10px 14px', fontSize: 13, color: COLORS.error, marginBottom: 14 }}>⚠️ {error}</div>}
        {success && <div style={{ background: '#F0FDF4', border: '1px solid #BBF7D0', borderRadius: 10, padding: '10px 14px', fontSize: 13, color: COLORS.success, marginBottom: 14 }}>✅ {isRtl ? 'تم تحديث كلمة المرور بنجاح' : 'Password updated successfully'}</div>}

        {!success && (
          <>
            <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: COLORS.text, marginBottom: 6 }}>{isRtl ? 'كلمة المرور الجديدة' : 'New Password'}</label>
            <input type="password" value={password} onChange={e => setPassword(e.target.value)} style={{ width: '100%', padding: '12px 14px', border: `1.5px solid ${COLORS.border}`, borderRadius: 12, fontSize: 14, fontFamily: 'Cairo, sans-serif', outline: 'none', boxSizing: 'border-box', marginBottom: 14, direction: isRtl ? 'rtl' : 'ltr' }} />

            <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: COLORS.text, marginBottom: 6 }}>{isRtl ? 'تأكيد كلمة المرور' : 'Confirm Password'}</label>
            <input type="password" value={confirm} onChange={e => setConfirm(e.target.value)} style={{ width: '100%', padding: '12px 14px', border: `1.5px solid ${COLORS.border}`, borderRadius: 12, fontSize: 14, fontFamily: 'Cairo, sans-serif', outline: 'none', boxSizing: 'border-box', marginBottom: 14, direction: isRtl ? 'rtl' : 'ltr' }} />

            <button onClick={handleReset} disabled={loading} style={{ width: '100%', padding: 14, background: `linear-gradient(135deg, ${COLORS.primary}, ${COLORS.primaryDark})`, border: 'none', borderRadius: 12, fontSize: 15, fontWeight: 700, color: '#fff', cursor: 'pointer', fontFamily: 'Cairo, sans-serif' }}>
              {loading ? (isRtl ? 'جارٍ الحفظ...' : 'Saving...') : (isRtl ? 'حفظ كلمة المرور' : 'Save Password')}
            </button>
          </>
        )}
      </div>
    </div>
  );
}
